import NotionPages from './NotionPages'

export default NotionPages
